import yup from '../../../../config/yup';

export const dedupTaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('dataOperation'),
  function: yup.string().default('dedup'),
  parameters: yup.object().shape({
    inputData: yup.string().required('Input Data is required'),
    targetData: yup.string().required('Target Data is required'),
    recordType: yup.string().required('Record Type is required'),
    duplicateOutputName: yup.string(),
    dedupResult: yup.string(),
  }),
});
